/**
 * -- MAIN.JS --
 * This file is the main entry point for Vite.
 * It imports the main SCSS file for all compiled CSS.
 * This theme also includes AlpineJS and HTMX.
 */

import 'vite/modulepreload-polyfill';
import './styles/main.scss';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import mask from '@alpinejs/mask';
import intersect from '@alpinejs/intersect';
import persist from '@alpinejs/persist';
import htmx from 'htmx.org';
import Glide from '@glidejs/glide';
import { initPostSliders } from './js/post-slider';
import { initHeroSliders } from './js/hero-slider';
import { initFadeAnimations } from './js/animations';
import productFilters from './js/product-filters';

// Alpine JS
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.plugin(mask);
Alpine.plugin(intersect);
Alpine.plugin(persist);

// Initialize fade animations
initFadeAnimations();

Alpine.data('productFilters', () => productFilters());
Alpine.start();

import './js/alpine-stores';

// HTMX - Make it globally available and initialize immediately
window.htmx = htmx;

// Process any existing hx-swap-oob elements immediately
if (typeof htmx !== 'undefined') {
  // Process any existing out-of-band swaps
  document.querySelectorAll('[hx-swap-oob]').forEach((el) => {
    htmx.process(el);
  });
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  console.log('Vite files loaded');
  // Re-process any HTMX elements to ensure they're properly initialized
  if (typeof htmx !== 'undefined') {
    htmx.process(document.body);
  }
  initPostSliders(Glide);
  initHeroSliders(Glide);
});
